module.exports = __webpack_public_path__ + "static/media/musee.ff1d2b84.webp";